module.exports = __webpack_public_path__ + "img/www.instagram.com.34ada163.png";